'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _interface = require('./interface');

exports['default'] = {
  name: 'ATableColumn',
  props: _interface.ColumnProps
};